import { Box, FormControl, Grid, IconButton, InputLabel, OutlinedInput, TextField } from "@mui/material";
import React, { useRef, useState } from "react";
import SendIcon from "@mui/icons-material/Send";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";
import { appLogger } from "../../../utils";
import Editor from "../../../utils/common/Editor";
interface IProps {
  label: string;
  handleMessageChange: any;
  newCC: string;
  newMessage: string;
  sendMail: any;
  base64: any;
  setBase64: any;
  fileName: string;
  fileType: string;
  setFileName: any;
  setFileType: any;
  handleCC: any;
  newSubject: string;
  handleSubject: any;
}

const RenderInputBox = (props: IProps) => {
  appLogger.info({ infoObj: { method: "RenderInputBox", component: "mailing", fileName: "renderInputBox.tsx", props: props } });
  const inputFile: any = useRef(null);
  const {
    label,
    handleMessageChange,
    handleCC,
    newCC,
    newMessage,
    sendMail,
    base64,
    setBase64,
    setFileName,
    setFileType,
    newSubject,
    handleSubject
  } = props;
  const onAddAttachmentClick = () => {
    if (base64) {
      setBase64("");
      setFileName("");
      setFileType("");
    } else if (inputFile && inputFile.current) {
      inputFile.current.click();
    }
  };

  const onFileInputChange = (e: any) => {
    const files = e.target.files;
    const file = files[0];
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      setBase64(reader.result);
      setFileName(file.name);
      setFileType(file.type);
    };
  };

  return (
    <Box sx={{ width: "100%", padding: "10px", backgroundColor: "#fff" }}>
      <input
        type="file"
        id="file"
        ref={inputFile}
        style={{ display: "none" }}
        onChange={onFileInputChange}
      />
      <Grid container sx={{ alignItems: "flex-end", flexWrap: "nowrap" }}>
        <Grid item sx={{ flexGrow: 1, mr: 1 }}>
          <div className="mailbox-input">
          {/* <TextField
              label="Subject"
              value={newSubject && label === "Reply" ? "Re: " + newSubject : newSubject}
              onChange={handleSubject}
              variant="standard"
              disabled={label === "Reply" ? true : false}
              fullWidth
            /> */}
            <FormControl
              className="custom-select custom-textarea"
              fullWidth
              style={{marginTop: "8px"}}
            >
            <InputLabel style={{marginBottom: "5px"}}>Subject</InputLabel>
            <OutlinedInput
              label="Subject"
              value={newSubject && label === "Reply" ? "Re: " + newSubject : newSubject}
              onChange={handleSubject}
              disabled={label === "Reply" ? true : false}
              fullWidth
            />
            </FormControl>
            <FormControl
              className="custom-select custom-textarea"
              fullWidth
              style={{marginBottom: "5px"}}
            >
            <InputLabel style={{marginBottom: "5px"}}>CC</InputLabel>
            <OutlinedInput
              label="CC"
              value={newCC}
              onChange={handleCC}
              fullWidth
            />
            </FormControl>
          <Editor
            className="email-reply-quill"
            updateData={handleMessageChange}
            editorData={newMessage}
            id="feedback-reply-mail-input"
            label={label}
          />
            {/* <Link
              sx={{
                display: "flex",
                alignItems: "center",
                mt: 1,
                fontSize: "12px",
                justifyContent: "flex-end",
              }}
              onClick={onAddAttachmentClick}
              title="Attachment"
              className="attach-link"
            >
              <AttachFileIcon />
              // {base64 ? "Remove attachment" : "Add attachment"} 

              {base64 ? (
                <IconButton color="primary" sx={{ p: "10px" }} title="Remove">
                  <DeleteIcon />
                </IconButton>
              ) : (
                <IconButton color="primary" sx={{ p: "10px" }} title="Add">
                  <AddIcon />
                </IconButton>
              )}
            </Link> */}
          </div>
        </Grid>
        <Grid item>
          <IconButton
            color="primary"
            sx={{ p: "10px", mb: "80px" }}
            aria-label="menu"
            onClick={sendMail}
            title="Send"
          >
            <SendIcon />
          </IconButton>
        </Grid>
      </Grid>
    </Box>
  );
};

export default RenderInputBox;
